import React from 'react';
import { Field } from 'formik';

import CheckboxesField from 'buyside/components/presentation/Form/Field/CheckboxesField/checkboxesField';

const { certificationTypes } = require('buyside/util/constantsFromRails.json');

const CertificationsForm = () => {
  return (
    <div>
      <Field
        component={CheckboxesField}
        name="userProfile.certifications"
        options={certificationTypes}
        numColumns={3}
      />
    </div>
  );
};

export default CertificationsForm;
